import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SetUser, SetUserAsAdmin, SetUserAsDICMember } from './user.actions';
import { UserStateModel } from '../../../model';

@State<UserStateModel>({
  name: 'user',
  defaults: {
    userid: '',
    roles: [],
    given_name: '',
    family_name: '',
    email: '',
    locale: '',
    name: '',
    nickname: '',
    picture: '',
    isDICMember: false,
    isAdmin: false,
  },
})
@Injectable()
export class UserState {
  @Selector()
  static user(state: UserStateModel): UserStateModel {
    return state;
  }

  @Selector()
  static isDICMember(state: UserStateModel): boolean {
    return state.isDICMember;
  }

  @Selector()
  static isAdmin(state: UserStateModel): boolean {
    return state.isAdmin;
  }

  @Action(SetUser)
  setUser({ getState, patchState }: StateContext<UserStateModel>, { payload }: { payload: UserStateModel }): void {
    patchState({
      ...getState(),
      ...payload,
    });
  }

  @Action(SetUserAsDICMember)
  setUserAsDICMember({ getState, patchState }: StateContext<UserStateModel>): void {
    patchState({
      ...getState(),
      isDICMember: true,
    });
  }

  @Action(SetUserAsAdmin)
  setUserAsAdmin({ getState, patchState }: StateContext<UserStateModel>): void {
    patchState({
      ...getState(),
      isAdmin: true,
    });
  }
}
